import React, { SVGProps } from 'react';

export const Copy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.284 5.716c-.584-3.496-2.458-3.99-8.158-3.99-7.502 0-8.402.87-8.402 8.4 0 5.7.496 7.574 3.99 8.16.586 3.48 2.476 3.99 8.162 3.99 7.5 0 8.4-.87 8.4-8.4 0-5.686-.512-7.576-3.992-8.16Zm-14.758 4.41c0-6.542-.002-6.6 6.6-6.6 6.6 0 6.6 0 6.6 6.6s0 6.6-6.6 6.6c-6.602 0-6.6-.06-6.6-6.6Zm10.35 10.35c-4.366 0-5.85 0-6.346-2.012h2.596c7.5 0 8.4-.868 8.4-8.398V7.47c1.98.496 2.01 1.98 2.01 6.346-.06 6.6-.12 6.66-6.66 6.66Z"
    />
  </svg>
);
